// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAmnt } from "../../../icons/mono/build/icon-amnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AmntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAmnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AmntIcon.displayName = 'AmntIcon';
}

export default AmntIcon;